import * as React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Container from 'components/Container';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';

import './styles/PendingGroupPage.scss';

type Props = {
  uuid: string;
  code: string;
  groupName: string;
  groupAvatarUrl: string;
  orgName: string | null;
  onCancelRequest: (groupUuid: string) => void;
};

export default function PendingGroupPage(props: Props) {
  const { code, groupName, groupAvatarUrl, orgName, onCancelRequest, uuid } = props;

  return (
    <div className="PendingGroupPage">
      <Container size="large">
        <Box>
          <BoxBody size="medium">
            <MediaObject>
              <Container className="PendingGroupPage-groupInfo" size="xxsmall">
                <TitleHeader
                  data-test="groupInfo"
                  title={groupName}
                  image={groupAvatarUrl}
                  imageCircle
                  imageSize="xxxsmall"
                  subtext={
                    <React.Fragment>
                      {orgName && <div>{orgName}</div>}
                      {`@${code}`}
                    </React.Fragment>
                  }
                  className="PendingGroupPage-groupName"
                  textAlign="center"
                  size="small"
                  flush
                />
              </Container>
              <Container className="PendingGroupPage-requestInfo" size="xxsmall">
                <TitleHeader
                  title="Your request to join this class has been sent."
                  subtext={
                    <Text>
                      Once a class owner approves, you’ll start receiving class announcements.{' '}
                      <Link
                        className="PendingGroupPage-learnMore"
                        href={LinkConstants.REQUEST_TO_JOIN}
                        weight="semibold"
                        eventElementName="PendingGroupPage-learnMore"
                        target="_blank">
                        Learn more
                      </Link>
                    </Text>
                  }
                  className="PendingGroupPage-title"
                  textAlign="left"
                  size="medium"
                  flush
                  action={
                    <Button
                      eventElementName="PendingGroupPage-cancel"
                      level="secondary"
                      size="small"
                      weight="semibold"
                      onClick={() => onCancelRequest(uuid)}>
                      Cancel request
                    </Button>
                  }
                />
              </Container>
            </MediaObject>
          </BoxBody>
        </Box>
      </Container>
    </div>
  );
}
